"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var _HelperMessages = _interopRequireDefault(require("../HelperMessages"));

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    leftChars: {
      color: theme.palette.text.primary
    }
  };
});
/**
 * CustomDataHelperText.
 *
 * @deprecated
 *
 * @param {object} props
 * @param {Array<string>} props.errors
 * @param {string} props.leftCharsMessage
 * @returns {React.ReactNode}
 * @example
 * // TODO: Write example.
 */

var CustomDataHelperText = function CustomDataHelperText(_ref) {
  var errors = _ref.errors,
      leftCharsMessage = _ref.leftCharsMessage;
  var classes = useStyles();
  return /*#__PURE__*/_react["default"].createElement(_material.Box, {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    width: 1
  }, /*#__PURE__*/_react["default"].createElement(_material.Box, null, /*#__PURE__*/_react["default"].createElement(_HelperMessages["default"], {
    messages: errors
  })), /*#__PURE__*/_react["default"].createElement(_material.Box, {
    className: classes.leftChars
  }, leftCharsMessage));
};

CustomDataHelperText.propTypes = {
  errors: _propTypes["default"].arrayOf(_propTypes["default"].string).isRequired,
  leftCharsMessage: _propTypes["default"].string.isRequired
};
var _default = CustomDataHelperText;
exports["default"] = _default;